import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef } from 'react';
import { StyledAlert } from './styles';
const SubmissionStatus = props => {
  const ref = useRef(null);
  const {
    hasErrors,
    submitTimes,
    ...otherProps
  } = props;

  // @hint do not define role=alert and aria-live at the same time because it
  // makes VoiceOver to announce the message twice.
  const alertProps = {
    severity: 'error',
    ref,
    tabIndex: -1,
    'aria-atomic': false,
    'aria-relevant': 'text',
    'data-auto': 'form-submission-status'
  };
  useEffect(() => {
    if (hasErrors) ref.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitTimes]);
  return hasErrors ? /*#__PURE__*/React.createElement(StyledAlert, _extends({}, alertProps, otherProps), "Some of the fields have errors, please review and try again:") : null;
};
export default SubmissionStatus;
//# sourceMappingURL=submission-status.js.map